import React from 'react';
import Wrapper from './StyledPage';

export const Training = () => {
  return <Wrapper>Training</Wrapper>;
};
